/**
 * Use this type instead of `AxisScaleConfig` when the values
 * shouldn't be provided by the user.
 */

/**
 * Config that is shared between cartesian and polar axes.
 */

/**
 * Use this type for advanced typing. For basic usage, use `XAxis`, `YAxis`, `RotationAxis` or `RadiusAxis`.
 */

export function isBandScaleConfig(scaleConfig) {
  return scaleConfig.scaleType === 'band';
}
export function isPointScaleConfig(scaleConfig) {
  return scaleConfig.scaleType === 'point';
}

/**
 * The data format returned by onAxisClick.
 */

/**
 * The axis configuration with missing values filled with default values.
 */

/**
 * The x-axis configuration with missing values filled with default values.
 */

/**
 * The y-axis configuration with missing values filled with default values.
 */